import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { View } from 'foundations-components/components/View';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import { useRouteOfferingType } from '../../common/hooks/useRouteOfferingType';
import { getStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const NoAccessError = () => {
  const offeringType = useRouteOfferingType();
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: "keys",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.error.noAccess.title",
      options: {
        offeringType: unescapedText(`marketplace-ui-assets-core.offeringType.${offeringType}_lowercase`)
      }
    }),
    type: "403",
    children: /*#__PURE__*/_jsx(View, {
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(UIRouterNavButton, {
        exact: true,
        to: getStorefrontRoute(offeringType),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.error.noAccess.button"
        })
      })
    })
  });
};
export default NoAccessError;